const desktop = window.matchMedia('(min-width: 1025px)');
const slotSelector = '[data-header-currency-switcher]';
const widgetSelector = '.bacurr-cur-blocker';
const languageSelector = '.tl-switcher-container.desktop, .localization-selectors';
const mobileLanguageSelector = '.tl-switcher-container.mobile';
const mobileRowSelector = '[data-header-mobile-selectors]';
const watchedSelector = `${slotSelector}, ${widgetSelector}, ${languageSelector}, ${mobileLanguageSelector}, ${mobileRowSelector}`;
let widget;
let originalPosition;
let mobileLanguage;
let originalLanguagePosition;
let pending = false;

function placeCurrencySwitcher() {
  pending = false;

  const currentWidget = document.querySelector(widgetSelector) || widget;
  const slot = document.querySelector(slotSelector);
  const language = slot?.parentElement.querySelector(languageSelector);
  const mobileRow = document.querySelector(mobileRowSelector);
  const mobileLanguageSlot = mobileRow?.querySelector('[data-header-mobile-language]');
  const mobileCurrencySlot = mobileRow?.querySelector('[data-header-mobile-currency]');
  const currentMobileLanguage = document.querySelector(mobileLanguageSelector) || mobileLanguage;

  if (!currentWidget) return;

  if (currentWidget !== widget) {
    originalPosition?.remove();
    originalPosition = document.createComment('currency-switcher-original-position');
    currentWidget.before(originalPosition);
    widget = currentWidget;
  }

  if (currentMobileLanguage && currentMobileLanguage !== mobileLanguage) {
    originalLanguagePosition?.remove();
    originalLanguagePosition = document.createComment('language-switcher-original-position');
    currentMobileLanguage.before(originalLanguagePosition);
    mobileLanguage = currentMobileLanguage;
  }

  if (!desktop.matches && mobileLanguageSlot && mobileCurrencySlot && mobileLanguage) {
    if (mobileLanguage.parentElement !== mobileLanguageSlot) {
      mobileLanguageSlot.append(mobileLanguage);
    }

    if (widget.parentElement !== mobileCurrencySlot) {
      mobileCurrencySlot.append(widget);
    }

    mobileRow.hidden = false;
    if (slot) slot.hidden = true;
    return;
  }

  if (originalLanguagePosition?.isConnected && mobileLanguage.parentNode !== originalLanguagePosition.parentNode) {
    originalLanguagePosition.after(mobileLanguage);
  }

  if (mobileRow) mobileRow.hidden = true;

  if (desktop.matches && slot && language && getComputedStyle(language).display !== 'none') {
    if (slot.previousElementSibling !== language) {
      language.after(slot);
    }

    if (widget.parentElement !== slot) {
      slot.append(widget);
    }

    slot.hidden = false;
  } else {
    if (originalPosition.isConnected && widget.parentNode !== originalPosition.parentNode) {
      originalPosition.after(widget);
    }

    if (slot) slot.hidden = true;
  }
}

function schedulePlacement() {
  if (pending) return;
  pending = true;
  requestAnimationFrame(placeCurrencySwitcher);
}

const observer = new MutationObserver((records) => {
  const relevantChange = records.some((record) =>
    [...record.addedNodes, ...record.removedNodes].some((node) =>
      node.nodeType === Node.ELEMENT_NODE &&
      (node.matches(watchedSelector) || node.querySelector(watchedSelector))
    )
  );

  if (relevantChange) schedulePlacement();
});

observer.observe(document.body, { childList: true, subtree: true });
desktop.addEventListener('change', schedulePlacement);
document.addEventListener('shopify:section:load', schedulePlacement);
placeCurrencySwitcher();
